import { z } from 'zod';

export const userRoleSchema = z.string();
